<mat-stepper
  [orientation]="stepperOrientation()"
  verticalStepperScroller
  #formlyStepper
  linear
  class="stepper-form-formly"
  (selectionChange)="onStepChange($event)"
>
  @for (
    step of visibleSteps();
    let index = $index;
    let last = $last;
    track step.id || index
  ) {
    <mat-step [completed]="isValid(step)">
      <ng-template matStepLabel>{{ step.props?.label }}</ng-template>
      <formly-field [field]="step"></formly-field>

      <div class="stepper-form-formly-actions">
        @if (props['autoSave']) {
          <button
            matButton="outlined"
            type="button"
            (click)="onSaveProgress()"
            [disabled]="!hasChanges"
          >
            {{ 'buttons.save' | translate }}
          </button>
        }
        @if (index !== 0) {
          <button
            matButton="tonal"
            matStepperPrevious
            class="btn btn-primary"
            type="button"
          >
            {{ 'buttons.back' | translate }}
          </button>
        }
        @if (!last) {
          <button
            matButton="filled"
            class="btn btn-primary"
            type="button"
            (click)="handleNextClick(step, true)"
          >
            {{ 'buttons.next' | translate }}
          </button>
        }
        @if (last) {
          <button
            matButton="filled"
            class="btn btn-primary"
            [disabled]="options.formState.hasOverview ? false : !form.valid"
            [type]="options.formState.hasOverview ? 'button' : 'submit'"
            (click)="
              options.formState.hasOverview ? handleNextClick(step, true) : ''
            "
          >
            {{
              (options.formState.hasOverview
                ? 'buttons.overview'
                : 'buttons.submit'
              ) | translate
            }}
          </button>
        }
      </div>
    </mat-step>
  }
  @if (options.formState.hasOverview) {
    <mat-step>
      <ng-template matStepLabel>{{
        'buttons.overview' | translate
      }}</ng-template>
      @if (overViewFields.length) {
        <formly-form
          aria-disabled="true"
          [fields]="overViewFields"
          [model]="model"
          [options]="options"
        ></formly-form>
      } @else {
        <div class="skeleton-container">
          <ngx-skeleton-loader
            animation="progress-dark"
            count="10"
            class="skeleton-description"
          />
        </div>
      }
      <div class="stepper-form-formly-actions">
        <button
          matButton="tonal"
          matStepperPrevious
          class="btn btn-primary"
          type="button"
        >
          {{ 'buttons.back' | translate }}
        </button>
        <button
          matButton="filled"
          class="btn btn-primary"
          [disabled]="!form.valid"
          type="submit"
        >
          {{ 'buttons.submit' | translate }}
        </button>
      </div>
    </mat-step>
  }
</mat-stepper>
